export enum NewItem {
    Ticket = 1,
    Email = 2,
    Contact = 3
}